import { Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import i18n from '../../../common/i18n';
import Reveal from '../commons/Reveal';
import SectionHeading from '../commons/SectionHeading';
import RequirementCard from '../commons/RequirementCard';
import { HOME_REQUISITES } from '../commons/homeData';
import { homeColors, sectionContentSx, sectionPadding } from '../style/homeStyles';

const Requisitos = ({ isMobile }) => (
  <Box
    component="section"
    sx={{
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: homeColors.bg2,
      borderRadius: isMobile ? '40px 40px 0 0' : '0',
      marginTop: '16px',
      padding: sectionPadding(isMobile),
      textAlign: 'left',
    }}
  >
    <Box sx={sectionContentSx}>
      <SectionHeading
        eyebrow={i18n.homeRequisitesEyebrow}
        title={i18n.homeRequisitesTitle}
        titleFontSize={isMobile ? 28 : 40}
      />

      {/* Mobile: tarjetas apiladas. Desktop: tres columnas. */}
      <Grid container spacing={isMobile ? 0 : 2} sx={{ marginTop: '6px' }}>
        {HOME_REQUISITES.map((requisite, index) => (
          <Grid item xs={12} lg={4} key={requisite.id} sx={{ marginBottom: isMobile ? '14px' : 0 }}>
            <Reveal delay={index * 90} sx={{ height: '100%' }}>
              <RequirementCard text={requisite.text} Icon={requisite.Icon} isMobile={isMobile} />
            </Reveal>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);

Requisitos.propTypes = {
  isMobile: PropTypes.bool,
};

Requisitos.defaultProps = {
  isMobile: false,
};

export default Requisitos;
